var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileFields = function SvgProfileFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "profile_fields_svg2__a",
    x1: 12.7,
    x2: 176.4,
    y1: 221.4,
    y2: 134.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#profile_fields_svg2__a",
    id: "profile_fields_svg2__b",
    x1: -13.3,
    x2: 150.4,
    y1: 172.6,
    y2: 85.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#profile_fields_svg2__a",
    id: "profile_fields_svg2__c",
    x1: -39.3,
    x2: 124.5,
    y1: 123.8,
    y2: 36.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#profile_fields_svg2__a",
    id: "profile_fields_svg2__d",
    x1: -63.2,
    x2: 100.5,
    y1: 78.9,
    y2: -8.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#profile_fields_svg2__a",
    id: "profile_fields_svg2__e",
    x1: -37.5,
    x2: 126.2,
    y1: 127.1,
    y2: 40
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#profile_fields_svg2__a",
    id: "profile_fields_svg2__f",
    x1: -11.8,
    x2: 151.9,
    y1: 175.3,
    y2: 88.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M190 172.6H56.3c-5.5 0-10-4.5-10-10s4.5-10 10-10H190c5.5 0 10 4.5 10 10s-4.5 10-10 10",
    style: {
      fill: "url(#profile_fields_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 110H56.3c-5.5 0-10-4.5-10-10s4.5-10 10-10H190c5.5 0 10 4.5 10 10s-4.5 10-10 10",
    style: {
      strokeWidth: 0,
      fill: "url(#profile_fields_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 47.3H56.3c-5.5 0-10-4.5-10-10s4.5-10 10-10H190c5.5 0 10 4.5 10 10s-4.5 10-10 10",
    style: {
      strokeWidth: 0,
      fill: "url(#profile_fields_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 38.1,
    r: 13.4,
    style: {
      strokeWidth: 0,
      fill: "url(#profile_fields_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 100,
    r: 13.4,
    style: {
      strokeWidth: 0,
      fill: "url(#profile_fields_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4,
    cy: 161.9,
    r: 13.4,
    style: {
      strokeWidth: 0,
      fill: "url(#profile_fields_svg2__f)"
    }
  }));
};
export default SvgProfileFields;